<template>
  <div class="info-severity-panel" :class="`info-severity-panel--${severity}`">
    <div class="info-severity-panel__icon">
      <img v-if="severity === 'critical'" src="@/assets/img/notifi-error.svg" alt="">
      <img v-else-if="severity === 'warning'" src="@/assets/img/warning-icon.svg" alt="">
      <img v-else src="@/assets/img/notifi-info-blue.svg" alt="">
    </div>
    <div class="info-severity-panel__text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppInfoTextPanel',
  props: {
    severity: {
      type: String,
    }
  }
}
</script>

<style lang="sass" scoped>
.info-severity-panel
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 15px
  padding: 8px
  border-radius: 10px

.info-severity-panel--critical
  background-color: #ffe0e2

.info-severity-panel--warning
  background-color: #ffedd7

.info-severity-panel--info
  background-color: #bde4fc

.info-severity-panel__icon
  flex-shrink: 0
  line-height: 0

.info-text-panel__text
  font-size: 13px

</style>
